export default {
  size: 'file is too large, max allowed 1024mb',
  image: 'file is not a image valid',
  confirm: 'The passwords are not same',
  password: 'Allowed lowercase and uppercase letters, numbers and _ - symbols',
  driver: 'There is not a driver selected',
  required: 'The field is required',
  requiredNumbers: 'The field can only contain Numbers',
  NotSpaces: 'The field cannot contain spaces',
  requiredMaxTen: 'The field must be exactly 10 characters',
  requiredMinTree: 'The field must be at least 3 characters'
}